import styled from 'styled-components';

export const ListBody = styled.div`
    overflow-y: auto;
    max-height: 270px;
    min-height: 150px;
`;
